/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForgotPasswordRequest as DigiworkMaitreDDtoAuthenticationForgotPasswordRequest } from '../../models/Digiwork/MaitreD/DTO/Authentication/forgot-password-request';

export interface ForgotPassword$Params {
      body?: DigiworkMaitreDDtoAuthenticationForgotPasswordRequest
}

export function forgotPassword(http: HttpClient, rootUrl: string, params?: ForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, forgotPassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

forgotPassword.PATH = '/api/pos/User/forgotpassword';
